import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import GenericHeader from "../../components/GenericHeader/GenericHeader";
import { Globals as OldGlobals } from "../../global/Globals";
import Popup from "../../components/PopUp/PopUp";
import "./CreateNewBrief.css";
import BriefForm from "./BriefForm";
import Button from "../../components/Button/Button";
import { createBriefAPI } from "../../services/createBriefAPI";
import Loader from "../../components/Loader/Loader";
import Toast from "../../components/Toast/Toast";
import { formatISO } from "date-fns";
import CryptoUtils from "../../util/cryptoUtils";
import { useDispatch, useSelector } from "react-redux";
import { setIsBriefDetailsInValid, setIsSaveAsDraftClicked, setIsEvalDetailsValid, setIsProducerDetailsValid } from "./CreateBriefSlice";
import { useLanguage } from '../../context/Languagecontext';

const CreateNewBrief = (props) => {

  const defaultFormData = {
    PROPOSAL_ID: "00000000-0000-0000-0000-000000000000",
    CHANNEL: 0,
    LANGUAGE: 0,
    GENRE: 0,
    FORMAT: 0,
    PRODUCTION_TYPE: 0,
    DESCRIPTION: "string",
    SUBMISSION_REQUIREMENT: "string",
    CLOSING_DATE: "2025-03-01T17:38:20.209Z",
    COMMISSIONING_EDITORS: ["3fa85f64-5717-4562-b3fc-2c963f66afa6"],
    CE_EVALUATION_DEADLINE: null,
    SENIOR_MANAGER_EVALUATION_DEADLINE: null,
    EVALUATION_PROCESS: "string",
    CRITERIA: [],
    EXTRA_CRITERIA: [
      {
        customCriteriaId: 0,
        customCriteriaName: "",
      },
    ], // optional
    BRIEF_TYPE: 0,
    PRODUCERS: [""],
  };
  const { Globals } = useLanguage();
  const optionalFields = ["EXTRA_CRITERIA", "CRITERIA", "EVALUATION_PROCESS"];
  const dispatch=useDispatch();
  const [popupState, setPopupState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [briefData, setBriefData] = useState(null);
  const [isValidated, setValidated] = useState(false);
  const [formData, setFormData] = useState(defaultFormData);
  const [clusterInfo, setClusterInfo] = useState(null);
  const [toast, setToast] = useState(null);
  const doesBriefHaveValue = useSelector(state => state.createBrief.isBriefDetailsPartiallyFilled);
  const doesEvalHaveValue = useSelector(state => state.createBrief.isEvaluationPartiallyFilled);
  const doesProducerSectionHaveValue = useSelector(state => state.createBrief.isProducerPartiallyFilled);
  useEffect(() => {
    const newCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    if (newCluster && newCluster.length > 0 && newCluster?.[0]) {
      setClusterInfo(newCluster?.[0]);
    }
  }, []);

  const handleToastClose = () => {
    setToast({ isOpen: false });
  };

  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    if (popupState === "brief" || popupState === "draft") {
      createBriefSeviceCall(popupState === "draft" ? 6 : 0);
    } else {
      navigate(-1);
    }
  }, [navigate, popupState]);

  const resetSates = () => {
    setPopupState("");
  };

  const postDateFormat = (date) => {
    return formatISO(date).split("+")[0];
  };

  const postData = (type) => {
    const data = {
      proposalId: formData.PROPOSAL_ID,
      proposalType: formData.BRIEF_TYPE,
      description: formData.DESCRIPTION,
      submissionRequirements: formData.SUBMISSION_REQUIREMENT,
      evalAndSelection: formData.EVALUATION_PROCESS,
      formatId: formData.FORMAT?.[0],
      languageId: formData.LANGUAGE?.[0],
      genreId: formData.GENRE?.[0],
      channelId: formData.CHANNEL?.[0],
      clusterId: clusterInfo?.clusterId || 1,
      productionTypeId: formData.PRODUCTION_TYPE?.[0],
      //closingDate: formData.CLOSING_DATE ? postDateFormat(formData.CLOSING_DATE) : "2025-07-30T00:00:00",
      briefStatus: type,
      //ceEvalDeadline: formData.CE_EVALUATION_DEADLINE ? postDateFormat(formData.CE_EVALUATION_DEADLINE):"2025-08-30T00:00:00",
      /*smEvalDeadline: formData.SENIOR_MANAGER_EVALUATION_DEADLINE ? postDateFormat(
        formData.SENIOR_MANAGER_EVALUATION_DEADLINE
      ):"2025-09-30T00:00:00",*/
      createdBy: "2f55b3fb-0607-40b0-831b-7f621a818541",
      updatedBy: "2f55b3fb-0607-40b0-831b-7f621a818541",
      criteriaIds: formData?.CRITERIA,
      customCriteriaList:
        formData?.EXTRA_CRITERIA?.filter((e) =>
          e.customCriteriaName?.trim()
        )?.map((e) => ({
          customCriteriaId: e?.customCriteriaId || 0,
          customCriteriaName: e?.customCriteriaName,
        })) || [],
      producers: formData?.PRODUCERS?.map((e) => e.id)?.filter((e) => e) || [],
      commisioningEditors:
        formData?.COMMISSIONING_EDITORS?.map((e) => e.id).filter((e) => e) ||
        [],
    };

    return data;
  };
  const createBriefSeviceCall = async (type) => {
    try {
      setLoading(true);
      const payload=postData(type);
      if (formData.CLOSING_DATE) {
        payload['closingDate'] = postDateFormat(formData.CLOSING_DATE);
      }
      if (formData.CE_EVALUATION_DEADLINE) {
        payload['ceEvalDeadline'] = postDateFormat(formData.CE_EVALUATION_DEADLINE);
      }
      if (formData.SENIOR_MANAGER_EVALUATION_DEADLINE) {
        payload['smEvalDeadline'] = postDateFormat(formData.SENIOR_MANAGER_EVALUATION_DEADLINE);
      }
      const response = await createBriefAPI(payload);
      setLoading(false);
      if (response.data.status === "OK") {
       
        navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "internal_dashboard", toastValue: (type === 0 ?Globals.CREATE_NEW_BRIEF.TOAST_CREATE_BRIEF_SUCCESS:Globals.CREATE_NEW_BRIEF.TOAST_SAVE_AS_DRAFT_SUCCESS) } });

      }
      else {
        setToast({ isOpen: true, status: "error", title: "Action Error: Error while creating a brief" });
        handleAutoCloseToast();
      }
    } catch (error) {
      setLoading(false);
      setToast({ isOpen: true, status: "error", title: "Action Error: Error while creating a brief" });
      handleAutoCloseToast();
      console.error("Error in create brief", error);
    }
  };
  const handleButtonClick = useCallback(
    (type) => {
      if (type === "brief") {
        if (isValidated) {
          setPopupState(type);
        } else {
          setPopupState("");
        }
      } else {
        if (type === "draft") {
          //combineAllFormData();
          dispatch(setIsSaveAsDraftClicked({ isSaveAsDraftClicked: true }));
        }
        setPopupState(type);
      }
    },
    [formData]
  );

  const validate = (newData) => {
    let isFormDataValid = Object.entries(newData)
      .filter(
        ([key]) =>
          ![
            ...optionalFields,
            newData.BRIEF_TYPE === 0 ? "PRODUCERS" : "",
          ].includes(key)
      ) // Filter out optional fields
      .every(([_, value]) => {
        if (Array.isArray(value)) {
          return value.length !== 0;
        }
        return value !== "" && value !== null;
      });

    if (isFormDataValid) {
      if (
        newData.CRITERIA.length === 0 &&
        newData.EXTRA_CRITERIA?.filter((e) => e.customCriteriaName?.trim())
          .length === 0
      ) {
        isFormDataValid = false;
      }
    }
    return isFormDataValid;
  };

  const combineAllFormData = useCallback((data) => {
    setFormData((prevData) => {
      const newData = { ...prevData, ...data };
      let isFormDataValid = validate(newData);
      const briefError = newData.CHANNEL.length > 0 &&
        (newData.CLOSING_DATE !== null && newData.CLOSING_DATE !== "") &&
        newData.DESCRIPTION.length > 0 &&
        newData.LANGUAGE.length > 0 &&
        newData.GENRE.length > 0 &&
        newData.FORMAT.length > 0 &&
        newData.PRODUCTION_TYPE.length > 0 &&
        newData.SUBMISSION_REQUIREMENT.length > 0;
      dispatch(setIsBriefDetailsInValid({ isBriefDetailsValid: briefError }));
      const evalError = (newData.SENIOR_MANAGER_EVALUATION_DEADLINE !== null && newData.SENIOR_MANAGER_EVALUATION_DEADLINE !== "") &&
        (newData.CE_EVALUATION_DEADLINE !== null && newData.CE_EVALUATION_DEADLINE !== "") &&
        (newData.COMMISSIONING_EDITORS !== null && newData.COMMISSIONING_EDITORS !== "") &&
        newData.CRITERIA.length > 0
      dispatch(setIsEvalDetailsValid({ isEvalDetailsValid: evalError }));
      const producerError = newData.BRIEF_TYPE.length > 0 &&
        (newData.BRIEF_TYPE === 'CLOSED' && newData.PRODUCERS.length > 0)
      dispatch(setIsProducerDetailsValid({ isProducerDetailsValid: producerError }));
      setValidated(isFormDataValid);
      return newData;
    });
  }, []);

  const resetStates = useCallback(() => {
    setPopupState(null);
  }, []);

  const showPopup = useCallback(
    (title, message, button1) => (
      <Popup
        title={title}
        text={message}
        normalAction={popupState !== "cross" ? handleBack : null}
        normalActionText={popupState !== "cross" ? button1 : ""}
        negativeAction={popupState === "cross" ? handleBack : null}
        negativeActionText={popupState === "cross" ? button1 : ""}
        popupType="abort"
        onClose={resetStates}
        buttonBGColor={popupState !== "cross" ? "#004894" : ""}
      />
    ),
    [handleBack, resetStates, popupState]
  );

  const handleAutoCloseToast = () => {
    setTimeout(() => {
      setToast({ isOpen: false });
    }, 4000);
  }
  return (
    <div className="create-newbrief-main-container">
      {loading && <Loader height={50} width={50} component={"Myproposals"} />}
      <div className="brief-form-header">
        <GenericHeader
          title={Globals.CREATE_NEW_BRIEF.HEADER_TITLE}
          onClose={() => handleButtonClick("cross")}
        />
      </div>
      <BriefForm
        propsData={briefData}
        formData={formData}
        handleDropdown={() => {}}
        handleTextAreaSelection={() => {}}
        handleInfo={() => {}}
        handleDatePicker={() => {}}
        handleCheckboxData={() => {}}
        handleBriefDetailsData={combineAllFormData}
        hanleEvaluationData={combineAllFormData}
        handleProducerData={combineAllFormData}
      />
      <div className="brief-button-group-container brief-fixed-footer">
        <div className="brief-button-group">
          <button
            className="brief-cancel-btn"
            onClick={() => handleButtonClick("cross")}
          >
            {Globals.CREATE_NEW_BRIEF.CANCEL_BUTTON}
          </button>
          <Button
            title={Globals.CREATE_NEW_BRIEF.SAVE_AS_DRAFT}
            additionalStyle={`brief-draft-btn ${
              (doesBriefHaveValue === true || doesEvalHaveValue === true || doesProducerSectionHaveValue === true) ? "" : "brief-draft-btn-disabled"
            }`}
            action={() => handleButtonClick("draft")}
            disabled={doesBriefHaveValue === true || doesEvalHaveValue === true || doesProducerSectionHaveValue === true}
          />
          <Button
            title={Globals.CREATE_NEW_BRIEF.CREATE_BRIEF}
            additionalStyle={
              isValidated ? "brief-create-btn-active" : "brief-create-btn-disabled"
            }
            id="Create-Brief-Button"
            action={() => handleButtonClick("brief")}
            disabled={!isValidated}
          />
        </div>
      </div>
      {popupState &&
        showPopup(
          Globals.CREATE_NEW_BRIEF.POPUP[popupState].TITLE,
          Globals.CREATE_NEW_BRIEF.POPUP[popupState].MESSAGE,
          Globals.CREATE_NEW_BRIEF.POPUP[popupState].BUTTON_TEXT
        )}
      {toast?.isOpen && (
        <Toast
          status={toast?.status}
          onClose={handleToastClose}
          title={toast?.title}
          extraClass={"toast-success-container-extra-style"}
        />
      )}
    </div>
  );
};

export default CreateNewBrief;
